import { render } from "./MentionsLegales.vue?vue&type=template&id=ea976216&scoped=true&ts=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=ts"
export * from "./MentionsLegales.vue?vue&type=script&lang=ts"

import "./MentionsLegales.vue?vue&type=style&index=0&id=ea976216&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea976216"]])

export default __exports__